import store from './store/index';
import { Provider } from 'react-redux';
import config from './constants/Config';
import { datadogLogs } from '@datadog/browser-logs';
import Enums from "./services/Enums";
import { useTranslation, withTranslation } from "react-i18next";
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import {ChatContainer} from './containers';

import React, {Suspense, useEffect, useState} from 'react';
import './App.css';
import {
    HashRouter,
    Switch,
    Route,
    Redirect
} from "react-router-dom";
const ILIframeContainer = React.lazy(() => import('./containers/ILIframeContainer'));
const IframeContainer = React.lazy(() => import('./containers/IframeContainer'));
const ValidateToken = React.lazy(() => import('./components/ValidateToken'));


export default function App() {
    const [isEnumInit, setEnumFetched] = useState({
        isLoaded: false
    })
    const [t,i18n] = useTranslation()
    document.body.dir = i18n.dir()


    useEffect(() => {
        const { logLevel, ...datadogInitConfig } = config.datadog;
        const env = datadogInitConfig.env;
        if (env.toLocaleLowerCase() == "production") {
            datadogLogs.init(datadogInitConfig);
            datadogLogs.logger.setLevel(logLevel);
        }
        !isEnumInit.isLoaded &&
        Enums.init()
            .then(a => {
                setEnumFetched({isLoaded: true})
            })

    }, [isEnumInit])


    let defaultURL = `/GB/${window.location.href.indexOf('?') == -1 ? '' : window.location.href.substring(window.location.href.indexOf('?'))}`;
    return (
        <div className="App">
              <Provider store={store}>
            <Suspense fallback={true}>
                <HashRouter basename='/'>
                    <Switch>
                        <Route exact path="/chat" component={ChatContainer}/>
                        <Route exact path="/" render={() => <Redirect to={defaultURL} />}/>
                        <Route exact path="/il" component={ILIframeContainer}/>
                        <Route exact path="/:country" component={IframeContainer}/>
                        <Route path="/add-payment-method/:token" component={ValidateToken}/>
                    </Switch>
                </HashRouter>
            </Suspense>
            </Provider>
        </div>

    );
}

